import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { profile } from "../../data/profile";

function Footer() {
  return (
    <StyledFooter>
      <span>© {new Date().getFullYear()} {profile.name}</span>
      <FooterLinks>
        <a href={profile.github} target="_blank" rel="noreferrer" aria-label="GitHub profile">
          <FontAwesomeIcon icon={faGithub} /> GitHub
        </a>
        <a href={profile.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn profile">
          <FontAwesomeIcon icon={faLinkedin} /> LinkedIn
        </a>
      </FooterLinks>
      <a href="#home">Back to top ↑</a>
    </StyledFooter>
  );
}

const StyledFooter = styled.footer`
  background: var(--bg-inverted);
  color: var(--text-on-inverted-muted);
  padding: 22px max(28px, calc((100vw - 1184px) / 2));
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  font-size: 0.7rem;
  font-weight: 650;

  a {
    color: var(--text-on-inverted);
    text-decoration: none;
  }

  a:hover {
    color: var(--accent-on-inverted);
  }
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 20px;

  a svg {
    margin-right: 6px;
  }
`;

export default Footer;
